import React, { useState, useRef, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import swordPlaceholder from "../../assets/images/sword.png";
import bannerHomeThumbPlaceholder from "../../assets/images/banner-thumb.png";
import { toast } from "sonner";
import "./banner.css";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  addNewBanner,
  deleteBanner,
  fetchBannersData,
  fetchEntities,
  saveBannerImage,
  updatedBanner,
} from "../../services/axios/apiManager";
import { FaWrench  } from "react-icons/fa";
import { handleErrors, validateImage } from "../../services/dataManager";
import { baseURL } from "../../services/axios/eps";
import { BannerValidations } from "./validations";
import LoadingSpinner from "../../Components/spinner";
import {  MdDeleteForever } from "react-icons/md";
import { FaLink } from "react-icons/fa6";
import BannerLinkingModal from "./bannerLinkingModal";

function Banner() {
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchingEntities, setFetchingEntities] = useState(false);
  const [activeBanner, setActiveBanner] = useState(null);
  const [leftImageURL, setLeftImageURL] = useState(null);
  const [rightImageURL, setRightImageURL] = useState(null);
  const [leftImage, setLeftImage] = useState(null);
  const [rightImage, setRightImage] = useState(null);
  const swordInputRef = useRef(null);
  const bannerHomeInputRef = useRef(null);
  const [isRMButton, setIsRMButton] = useState(false);
  const [showLinkingModal, setShowLinkingModal] = useState(false);
  const [entities, setEntities] = useState([]);

  /////////////////////////////////////////////////New Banner Place Holder
  const handleAddBanner = () => {
    const newBanner = {
      id: 0,
      heading: "New Banner",
      content: "Enter your banner description here",
      bread_crumbs: "New > Banner > BreadCrumbs",
      left_image: swordPlaceholder,
      right_image: bannerHomeThumbPlaceholder,
      module_name: null,
      module_id: null,
    };
    const isExist = banners.some((f) => f.id === 0);
    if (!isExist) {
      setBanners([...banners, newBanner]);
      setActiveBanner(newBanner);
    }
  };

  /////////////////////////////////////////////////Fetch Banners Data From API
  const getBannersData = async () => {
    const res = await fetchBannersData();
    if (res?.data?.success && res?.data?.data) {
      setBanners(res.data.data);
      setActiveBanner(res.data.data[0]);
      setLoading(false);
    } else {
      handleErrors(res, navigate, "Banners: ");
    }
  };
  const handleRemoveLink = async () => {
    setActiveBanner((prev) => ({
      ...prev,
      module_type: null,
      module_id: null,
    }));
    setIsRMButton(false);
  };
  /////////////////////////////////////////////////Add/Update Banners
  const HandleSubmit = async () => {
    const data = {
      heading: activeBanner.heading.trim(),
      content: activeBanner.content.trim(),
      bread_crumbs: activeBanner.bread_crumbs.trim(),
      module_type: activeBanner.module_type || null,
      module_id: activeBanner.module_id || null,
    };
    try {
      if (activeBanner?.id > 0) {
        await BannerValidations.validate(data, { abortEarly: false });
        const res = await updatedBanner({ id: activeBanner?.id, ...data });
        if (res?.data?.success) {
          if (leftImage) {
            await uploadImage(activeBanner.id, leftImage, "left");
          }
          if (rightImage) {
            await uploadImage(activeBanner.id, rightImage, "right");
          }
          setLeftImageURL(null);
          setRightImageURL(null);
          setLeftImage(null);
          setRightImage(null);
          await getBannersData();
          toast.success("Banner has been updated", { autoClose: 2000 });
        } else {
          handleErrors(res, navigate, "Update Banner");
        }
      } else {
        await BannerValidations.validate(data, { abortEarly: false });
        const res = await addNewBanner(data);
        if (res?.data?.success && res?.data?.data) {
          const { id } = res.data.data;
          if (leftImage) {
            await uploadImage(id, leftImage, "left");
          } else {
            saveFallBackImage(id, swordPlaceholder, "left");
          }
          if (rightImage) {
            await uploadImage(id, rightImage, "right");
          } else {
            saveFallBackImage(id, bannerHomeThumbPlaceholder, "right");
          }
          setLeftImageURL(null);
          setRightImageURL(null);
          setLeftImage(null);
          setRightImage(null);
          await getBannersData();
          toast.success("Banner has been added", { autoClose: 2000 });
        } else {
          handleErrors(res, navigate, "New Banner");
        }
      }
    } catch (error) {
      toast.error(error.inner[0].message, { autoClose: 2000 });
    }
  };

  /////////////////////////////////////////////////Bread Crumbs Field
  const handleBreadCrumbsChange = (e) => {
    setActiveBanner((prev) => ({ ...prev, bread_crumbs: e.target.innerText }));
  };

  /////////////////////////////////////////////////Heading Field
  const handleHeadingChange = (e) => {
    setActiveBanner((prev) => ({ ...prev, heading: e.target.innerText }));
  };

  /////////////////////////////////////////////////Content Field
  const handleContentChange = (e) => {
    setActiveBanner((prev) => ({ ...prev, content: e.target.innerText }));
  };

  /////////////////////////////////////////////////Chane Left Side Image
  const handleLeftImageChange = async (e) => {
    e.preventDefault();
    if (e?.target?.files && e.target.files[0]) {
      const file = e.target.files[0];
      if (!validateImage(file)) {
        e.target.value = "";
        setLeftImage(null);
        setLeftImageURL(null);
        return;
      }
      const previewUrl = URL.createObjectURL(file);
      setLeftImageURL(previewUrl);
      setLeftImage(file);
    } else {
      setLeftImage(null);
      setLeftImageURL(null);
    }
  };

  /////////////////////////////////////////////////Chane Right Side Image
  const handleRightImageChange = async (e) => {
    e.preventDefault();
    if (e?.target?.files && e.target.files[0]) {
      const file = e.target.files[0];
      if (!validateImage(file)) {
        e.target.value = "";
        setRightImage(null);
        setRightImageURL(null);
        return;
      }
      const previewUrl = URL.createObjectURL(file);
      setRightImageURL(previewUrl);
      setRightImage(file);
    } else {
      setRightImage(null);
      setRightImageURL(null);
    }
  };

  /////////////////////////////////////////////////Upload Images
  const saveFallBackImage = async (id, image, section) => {
    fetch(image)
      .then((res) => res.blob())
      .then(async (blob) => {
        const placeholderFile = new File([blob], "placeholder.png", {
          type: "image/png",
        });

        await uploadImage(id, placeholderFile, section);
      })
      .catch((error) => console.error("Error loading placeholder:", error));
  };
  const uploadImage = async (id, img, section) => {
    const formData = new FormData();
    formData.append("imageSection", section);
    formData.append("image", img);
    const res = await saveBannerImage(id, formData);
    if (!res?.data?.success) {
      handleErrors(res, navigate, `${section} image`);
    }
  };

  /////////////////////////////////////////////////Delete Banner
  const handleDeleteBanner = async () => {
    if (activeBanner?.id > 0) {
      const res = await deleteBanner(activeBanner.id);
      if (res?.data?.success) {
        await getBannersData();
        toast.success("Banner has been deleted", { autoClose: 2000 });
      }
    } else {
      const temp = banners.filter((f) => f.id !== activeBanner.id);
      setBanners(temp);
      setActiveBanner(banners[0]);
    }
  };
  // // // Fetcing Linking entities
  const getEntitiesData = async (str) => {
    const res = await fetchEntities(str);
    if (res?.data?.success && res?.data?.data) {
      setEntities(res.data.data);
    }
  };
  // // // open linking modal logic
  const handleOpenLinkinModal = async () => {
    setFetchingEntities(true);
    if (activeBanner?.module_type && activeBanner?.module_id) {
      await getEntitiesData(activeBanner.module_type);
      setShowLinkingModal(true);
    } else {
      setShowLinkingModal(true);
    }
    setFetchingEntities(false);
  };
  useEffect(() => {
    getBannersData();
  }, []);

  useEffect(() => {
    if (activeBanner?.module_type && activeBanner?.module_id) {
      setIsRMButton(true);
    } else {
      setIsRMButton(false);
    }
  }, [activeBanner]);
  return (
    <DashboardLayout>
      <Container>
        <div className="mt-5">
          <section className="bannerHome">
            <div>
              <div className="row">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                  <ul
                    className="nav nav-pills arrow-navtabs nav-secondary gap-2 flex-grow-1"
                    role="tablist"
                  >
                    {banners.map((banner, index) => (
                      <li
                        className="nav-item"
                        role="presentation"
                        key={banner.id}
                      >
                        <a
                          className={`nav-link ${activeBanner?.id === banner.id ? "active" : ""}`}
                          data-bs-toggle="tab"
                          role="tab"
                          style={{ cursor: "pointer" }}
                          aria-selected="false"
                          tabIndex={-1}
                          onClick={() => {
                            setLeftImageURL(null);
                            setRightImageURL(null);
                            setLeftImage(null);
                            setRightImage(null);
                            setActiveBanner(banner);
                          }}
                        >
                          Banner {index + 1}
                        </a>
                      </li>
                    ))}
                  </ul>
                  <div className="ms-auto">
                    <button
                      className="btn btn-primary mt-3 btn btn-success d-flex align-items-center gap-2"
                      onClick={handleAddBanner}
                    >
                      + Add New Banner
                    </button>
                  </div>
                </div>
                <div className="col-xxl-12">
                  {activeBanner && (
                    <div className="tab-content mt-3">
                      <div className="tab-pane fade show active">
                        <div className="bannerHome__content">
                          <div className="bannerHome__content-inner">
                            <button
                              className="btn btn-danger mt-3"
                              id="deleteButton"
                              onClick={() => {
                                handleDeleteBanner();
                              }}
                              style={{
                                position: "absolute",
                                top: "-1px",
                                right: "13px",
                              }}
                            >
                              Delete
                            </button>

                            <div
                              style={{
                                display: "flex",
                                fontWeight: "500",
                                gap: "16px",
                              }}
                            >
                              <p
                                contentEditable={true}
                                onBlur={handleBreadCrumbsChange}
                                suppressContentEditableWarning={true}
                              >
                                {activeBanner?.bread_crumbs}
                              </p>
                            </div>
                            <h1
                              className="title-animation stroked-text fw-8 mt-8"
                              contentEditable={true}
                              suppressContentEditableWarning={true}
                              onBlur={handleHeadingChange}
                            >
                              {activeBanner?.heading}
                            </h1>
                            <p
                              className="text-xl mt-6"
                              contentEditable={true}
                              suppressContentEditableWarning={true}
                              onBlur={handleContentChange}
                            >
                              {activeBanner.content}
                            </p>
                            {isRMButton ? (
                              <div className="section__cta">
                                <div className="btn-wrapper">
                                  <button
                                    className="btn btn-success"
                                    onClick={() => {}}
                                  >
                                    Read More
                                  </button>
                                  <Button
                                    title="Link button"
                                    className="ml-2"
                                    variant="outline-info"
                                    size="sm"
                                    disabled={fetchingEntities}
                                    onClick={() => {
                                      handleOpenLinkinModal();
                                    }}
                                  >
                                    {fetchingEntities ? (
                                      <span className="spinner-border spinner-border-sm text-light"></span>
                                    ) : activeBanner?.module_id ? (
                                      <FaWrench
                                        style={{
                                          fontSize: "15px",
                                        }}
                                      />
                                    ) : (
                                      <FaLink
                                        style={{
                                          fontSize: "15px",
                                        }}
                                      />
                                    )}
                                  </Button>
                                  <Button
                                    className="ml-2"
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => handleRemoveLink()}
                                  >
                                    <MdDeleteForever
                                      style={{
                                        fontSize: "15px",
                                      }}
                                    />
                                  </Button>
                                </div>
                              </div>
                            ) : (
                              <div className="section__cta">
                                <div className="btn-wrapper">
                                  <button
                                    className="btn btn-link p-0 m-0 border-0 text-light "
                                    onClick={() => {
                                      setIsRMButton(!isRMButton);
                                    }}
                                  >
                                    + Add Read More Button
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="sword">
                            <img
                              crossorigin="anonymous"
                              src={
                                leftImageURL
                                  ? leftImageURL
                                  : activeBanner?.id === 0
                                    ? activeBanner.left_image
                                    : activeBanner?.left_image
                                      ? `${baseURL}/uploads/file/${activeBanner.left_image}`
                                      : swordPlaceholder
                              }
                              alt="Select Image"
                              style={{ width: "100px", cursor: "pointer" }}
                              onClick={() => swordInputRef.current.click()}
                            />
                            <input
                              type="file"
                              accept="image/png, image/jpeg, image/webp"
                              ref={swordInputRef}
                              style={{ display: "none" }}
                              onChange={(e) => handleLeftImageChange(e)}
                            />
                            <span className="text-light small d-block">Max 10MB</span>
                          </div>
                          <div className="bannerHome__thumb">
                            <img
                              crossorigin="anonymous"
                              src={
                                rightImageURL
                                  ? rightImageURL
                                  : activeBanner?.id === 0
                                    ? activeBanner.right_image
                                    : activeBanner?.right_image
                                      ? `${baseURL}/uploads/file/${activeBanner.right_image}`
                                      : swordPlaceholder
                              }
                              alt="bannerHome"
                              style={{ cursor: "pointer" }}
                              onClick={() => bannerHomeInputRef.current.click()}
                            />
                            <input
                              type="file"
                              accept="image/png, image/jpeg, image/webp"
                              ref={bannerHomeInputRef}
                              style={{ display: "none" }}
                              onChange={(e) => handleRightImageChange(e)}
                            />
                            <span className="text-light small d-block">Max 10MB</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {banners?.length <= 0 && (
                <div className="constainer-fluid">
                  <div className="d-flex justify-content-center align-items-center">
                    {loading ? (
                      <LoadingSpinner size={"lg"} />
                    ) : (
                      <p className="h5 text-light">
                        There is curently no data for banners.
                      </p>
                    )}
                  </div>
                </div>
              )}
              {banners?.length > 0 && (
                <div className="constainer-fluid">
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn-primary mt-8 mb-3 btn btn-success d-flex align-items-center gap-2"
                      onClick={HandleSubmit}
                    >
                      {activeBanner?.id > 0 ? "Update Content" : "Save Content"}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
        <BannerLinkingModal
          showLinkingModal={showLinkingModal}
          setShowLinkingModal={setShowLinkingModal}
          activeBanner={activeBanner}
          setActiveBanner={setActiveBanner}
          setIsRMButton={setIsRMButton}
          entities={entities}
          setEntities={setEntities}
          getEntitiesData={getEntitiesData}
        />
      </Container>
    </DashboardLayout>
  );
}

export default Banner;
